export default __webpack_public_path__ + "static/mentions-711300cdc37f03a8dda2dbde504523ae.png";